<template>
  <Teleport :to="`#search-engine-top-${screenWidth < 992 ? 'mobile' : 'desktop'}`">
    <div class="search-engine-top">
      <div class="search-engine-top__inner" style="transition: 3s linear width">
        <svg class="search-engine-top__icon" @click="handleOpen($event)">
          <use xlink:href="#svg-magnifying"></use>
        </svg>
        <transition name="show" :css="false" @enter="enter" @leave="leave">
          <div v-if="openItems" class="search-engine-top-nav">
            <svg v-if="screenWidth < 992" class="search-engine-top-nav__icon">
              <use xlink:href="#svg-magnifying"></use>
            </svg>
            <input
              type="text"
              class="search-engine-top-nav__input"
              :placeholder="result.placeholder"
              @input="handlerInput($event)"
              @keyup.enter="goSearchCatalog"
            />
            <svg class="search-engine-top-nav__close" @click="handleOpen($event)">
              <use xlink:href="#svg-close"></use>
            </svg>
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="response && response.products && openItems && response.products.items"
            class="search-engine-top__response"
          >
            <PerfectScrollbar class="search-engine-top__elements">
              <!--                        <div class="search-engine-top__top">-->
              <!--                            <h6 class="search-engine-top__title">Шукати в категорії (нужны данные)</h6>-->
              <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
              <!--                                Каблучки з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
              <!--                            </a>-->
              <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
              <!--                                Сережки з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
              <!--                            </a>-->
              <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
              <!--                                Кулони з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
              <!--                            </a>-->
              <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
              <!--                                Аксесуари з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
              <!--                            </a>-->
              <!--                        </div>-->
              <!--                        {{response.products && response.products.items}}-->
              <div
                v-if="response.products && response.products.items"
                class="search-engine-top__middle"
              >
                <h6
                  v-if="response.messages && response.messages.sectionsTitle"
                  class="search-engine-top__title"
                >
                  {{ response.messages.sectionsTitle }}
                </h6>
                <div class="search-engine-top-sections">
                  <p v-for="section in response?.sections" class="search-engine-top-sections__item">
                    {{ section.name }} {{ response.messages.to }}&nbsp;
                    <a :href="section.url">{{ response.query }}</a>
                  </p>
                </div>
              </div>
              <div
                v-if="response.products && response.products.items"
                class="search-engine-top__middle"
              >
                <h6
                  v-if="response.messages && response.messages.itemsTitle"
                  class="search-engine-top__title"
                >
                  {{ response.messages.itemsTitle }}
                </h6>
                <div class="search-engine-top__items">
                  <SearchProduct v-for="item in response.products.items" :result="item" />
                </div>
              </div>
            </PerfectScrollbar>
            <div
              v-if="response.products && response.products.items && response.products.items.length"
              class="search-engine-top__bottom"
            >
              <DefButtonPrimary
                v-if="response.messages && response.messages.allResults"
                :href="response.url"
              >
                {{ response.messages.allResults }}
              </DefButtonPrimary>
              <!--              <a-->
              <!--                v-if="response.messages && response.messages.allResults"-->
              <!--                :href="response.url"-->
              <!--                class="def-button"-->
              <!--                >{{ response.messages.allResults }}</a-->
              <!--              >-->
            </div>
          </div>
        </transition>
      </div>
    </div>
  </Teleport>
</template>

<script>
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { screenWidth } from '@use/useDeviceInfo';
import SearchProduct from '@components/Search/SearchProduct/SearchProduct.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

export default {
  name: 'SearchEngineTop',
  components: { GiaPhoto, PerfectScrollbar, SearchProduct, DefButtonPrimary },
  props: {
    result: {
      type: Object,
      default: () => ({
        ajax: {
          url: '/ajax.php',
          data: {
            action: 'search',
            ajax: 'y',
            lang: 'ru',
            q: 'safd',
          },
          searchName: 'q',
          delay: 100,
        },
        placeholder: 'Поиск',
      }),
    },
    className: {
      type: String,
    },
  },
  data() {
    return {
      response: {},
      value: '',
      timeout: '',
      openItems: false,
      inputAnimationWidth: 0,
      inputAnimationStep: 0,
      screenWidth,
    };
  },
  methods: {
    handlerInput(e) {
      const { result } = this;
      let delay = 1000;
      if (result && result.ajax && result.ajax.searchName) {
        delay = result.ajax.searchName;
      }
      this.value = e.target.value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.getSearchElements.bind(this), delay);
    },
    async getSearchElements() {
      try {
        const { result } = this;

        if (
          result &&
          result.ajax &&
          result.ajax.url &&
          result.ajax.searchName &&
          this.value !== ''
        ) {
          const { data } = result.ajax;
          data[result.ajax.searchName] = this.value;
          const response = await axios.get(result.ajax.url, { params: data });
          this.response = response.data;
          this.openItems = true;
          // this.handlerClickGtag();
        } else {
          this.response = {};
        }
      } catch (err) {
        console.error(err);
      }
    },
    handlerClickGtag() {
      try {
        const product = this.response?.gtag?.data;
        if (product) {
          gtag('event', 'add_to_cart', {
            send_to: 'AW-440849847',
            value: product.value,
            items: product.items,
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleOpen() {
      if (this.value === '') this.response = {};
      this.openItems = !this.openItems;

      if (this.openItems) {
        document.addEventListener('click', this.handlerAnotherClick, true);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick, true);
        this.response = {};
      }
    },
    handlerAnotherClick({ target }) {
      const parent = target.closest('.search-engine-top');
      if (!parent) {
        this.openItems = false;
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    inputAnimationEnter(el, done) {
      el.style.width = `${this.inputAnimationStep}px`;

      // this.inputAnimationStep += 7;

      if (
        this.inputAnimationWidth - this.inputAnimationStep < 7 &&
        this.inputAnimationWidth - this.inputAnimationStep !== 0
      ) {
        this.inputAnimationStep += this.inputAnimationWidth - this.inputAnimationStep;
      } else {
        this.inputAnimationStep += 7;
      }

      if (this.inputAnimationStep <= this.inputAnimationWidth) {
        requestAnimationFrame(() => this.inputAnimationEnter(el, done));
      } else {
        done();
      }
    },
    inputAnimationLeave(el, done) {
      el.style.width = `${this.inputAnimationStep}px`;
      this.inputAnimationStep -= 7;
      if (this.inputAnimationStep > 0) {
        requestAnimationFrame(() => this.inputAnimationLeave(el, done));
      } else {
        done();
      }
    },
    enter(el, done) {
      if (this.screenWidth >= 992) {
        this.inputAnimationWidth = el.clientWidth;
      } else {
        this.inputAnimationWidth = this.screenWidth;
      }

      requestAnimationFrame(() => this.inputAnimationEnter(el, done));
    },
    leave(el, done) {
      requestAnimationFrame(() => this.inputAnimationLeave(el, done));
    },
    goSearchCatalog() {
      window.location.href = `${this.result.page.href}?q=${this.value}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-engine-top {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  //height: 20px;
  align-self: stretch;
  @include point-md {
    width: 24px;
  }
  @include point-lg {
    margin-right: 24px;
    height: 24px;
    position: relative;
  }
  &__middle {
    border-bottom: 1px solid #dfdfdf;
    padding-bottom: 8px;
  }
  &__inner {
    display: flex;
    align-items: center;
    height: 100%;
    background-color: #fff;
    @include point-lg {
      right: 0;
      position: absolute;
      z-index: 3;
      left: unset;
      height: unset;
    }
  }
  &__icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: 0.2s linear fill;
    fill: #191918;
    @include point-md {
      width: 24px;
      height: 24px;
    }
    &:hover {
      fill: var(--text-colour-secondary);
    }
  }
  &__response {
    position: absolute;
    top: calc(100% + 50px);
    left: -16px;
    right: 0;
    z-index: 3;
    background-color: #fff;
    color: var(--text-colour-primary);
    width: 100vw;
    border-top: 1px solid #dfdfdf;
    @include point-md {
      left: -24px;
    }
    @include point-lg {
      top: 100%;
      left: 0;
      width: unset;
    }
  }
  &__elements {
    padding: 0 16px 4px;
    max-height: 388px;
    overflow-y: auto;
    @include point-md {
      padding: 16px 24px 4px;
    }
  }
  &__category {
    display: flex;
    margin-bottom: 16px;
  }
  &__title {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: #757575;
    margin: 16px 0 8px;
  }
  &__blue {
    color: var(--text-colour-secondary);
    margin-left: 3px;
  }
  &__top {
    border-bottom: 1px solid #dfdfdf;
    margin-bottom: 16px;
  }
  &__bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    border-top: 1px solid #dfdfdf;
    padding: 0 16px;
    :deep(.def-button-primary) {
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: 1.44px;
      @include point-md {
        width: unset;
        padding: 0 48px;
      }
    }
  }
  .def-title-6 {
    font-weight: 500;
    font-size: rem(12);
    line-height: 115%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: rem(14);
    }
  }
}
.search-engine-top-nav {
  display: flex;
  align-items: center;
  width: calc(100vw - 100px);
  background-color: #fff;
  position: absolute;
  top: 100%;
  left: -16px;
  z-index: 1;
  height: 52px;
  padding: 0 16px;
  overflow: hidden;
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;

  @include point-md {
    left: -24px;
  }
  @include point-lg {
    width: 344px;
    position: static;
    height: unset;
    padding: 0;
    border-top: unset;
    border-bottom: unset;
  }
  &__close {
    width: 16px;
    height: 16px;
    transition: 0.2s linear fill;
    flex-shrink: 0;
    &:hover {
      cursor: pointer;
      fill: var(--background-red);
    }
  }
  &__input {
    border: none;
    width: 100%;
    padding: 5px 10px;
    margin: 5px 8px 5px 0;
  }
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    flex-shrink: 0;
  }
}
.search-engine-top-sections {
  display: grid;
  grid-auto-rows: 42px;
  font-size: 16px;
  a {
    color: #618eaf;
  }
  &__item {
    display: flex;
    align-items: center;
  }
}
</style>
